import { PersonLiteDto } from '../../api/person/models/PersonDto'
import { getProfilePicUrl, formatPersonName } from '../../utils/personUtils'

export interface Props {
    personLite: PersonLiteDto
}

export default function HelixSearchPersonFilterTag({
    personLite,
}: Props): React.JSX.Element {
    return (
        <div className="flex gap-2 items-center">
            <img
                src={getProfilePicUrl(personLite, true)}
                className="rounded-full w-6 h-6"
                onError={(e: React.SyntheticEvent<HTMLImageElement>) => {
                    e.currentTarget.onerror = null // Prevent infinite loop if fallback image also fails
                    e.currentTarget.src = '/no-profile-pic.svg'
                }}
            />
            <span>{formatPersonName(personLite)}</span>
        </div>
    )
}
